import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactoresCriticidadServices from "./FactoresCriticidad.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFactoresCriticidad =
  (filters, setLoading, setFactoresCriticidad, setFactoresCriticidadError) =>
  async (dispatch) => {
    try {
      setLoading
        ? setLoading(true)
        : dispatch({
            type: actions.LOADING_FACTORES_CRITICIDAD,
            payload: true,
          });
      const resp = await FactoresCriticidadServices.getFactoresCriticidad(
        filters
      );
      setFactoresCriticidad
        ? setFactoresCriticidad(resp.data)
        : dispatch({
            type: actions.GET_FACTORES_CRITICIDAD,
            payload: resp.data,
          });
      setFactoresCriticidadError
        ? setFactoresCriticidadError("")
        : dispatch({
            type: actions.FACTORES_CRITICIDAD_FAIL,
            payload: "",
          });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      setFactoresCriticidadError
        ? setFactoresCriticidadError(message)
        : dispatch({
            type: actions.FACTORES_CRITICIDAD_FAIL,
            payload: message,
          });
    } finally {
      setLoading
        ? setLoading(false)
        : dispatch({
            type: actions.LOADING_FACTORES_CRITICIDAD,
            payload: false,
          });
    }
  };

export const saveFactoresCriticidad =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_FACTORES_CRITICIDAD,
        payload: true,
      });
      const resp = await FactoresCriticidadServices.saveFactoresCriticidad(req);
      const { factoresCriticidad } = getState().factoresCriticidad
      const _factoresCriticidad = factoresCriticidad
      _factoresCriticidad.data = [...factoresCriticidad.data, resp.data]
      dispatch({
        type: actions.GET_FACTORES_CRITICIDAD,
        payload: _factoresCriticidad
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_FACTORES_CRITICIDAD,
        payload: false,
      });
    }
  };

export const editFactoresCriticidad =
  (req, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_FACTORES_CRITICIDAD,
        payload: true,
      });
      const resp = await FactoresCriticidadServices.editFactoresCriticidad(
        id,
        req
      );
      const { factoresCriticidad } = getState().factoresCriticidad
      const _factoresCriticidad = factoresCriticidad
      _factoresCriticidad.data[index] = resp.data;
      dispatch({
        type: actions.GET_FACTORES_CRITICIDAD,
        payload: _factoresCriticidad
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_FACTORES_CRITICIDAD,
        payload: false,
      });
    }
  };

export const deleteFactoresCriticidad =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_FACTORES_CRITICIDAD,
        payload: true,
      });
      await FactoresCriticidadServices.deleteFactoresCriticidad(id);
      const { factoresCriticidad } = getState().factoresCriticidad
      const _factoresCriticidad = factoresCriticidad
      _factoresCriticidad.data.splice(index, 1);
      dispatch({
        type: actions.GET_FACTORES_CRITICIDAD,
        payload: _factoresCriticidad
      });
      dispatch({
        type: actions.FACTORES_CRITICIDAD_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.LOADING_FACTORES_CRITICIDAD,
        payload: false,
      });
    }
  };
